import { ListContextProvider, useListController } from "ra-core"
import { FC } from "react"
import { Box} from '@mui/material'
import { useResourceRegister } from '@/utils/resourceRegister'
import UsersTable from "@/components/settings/users/UsersTable"
import InvitationTable from "@/components/settings/users/InvitationTable"
import useIdTokenUser from "@/authProvider/useIdTokenUser"
import { useLocation } from "react-router-dom"
import { parse } from "@/utils/queryStringWrapper"
import RolesList from "./RolesList"
import UserManageAmbientDataContextProvider from "@/components/settings/users/UserManageAmbientDataContextProvider"
import { UserStatus } from "@/gen/api/user"



const UserManage: FC = () => {
  useResourceRegister({
    name: 'user-invitation'
  })
  useResourceRegister({
    name: 'org-roles'
  })

  const location = useLocation()
  const mode = parse(location.search)['manage-role'] === 'true' ? 'role' : 'user'

  return (
    mode === 'user' ?
    <UserManageDefaultLists /> :
    <RolesList />
  )
}

export default UserManage;


const UserManageDefaultLists: FC = () => {
  const controllerProps = useListController({ basePath: '', perPage: 5, filterDefaultValues: {status: UserStatus.Active} })
  const invitationCtrlProps = useListController({ resource: 'user-invitation', basePath: '', perPage: 5})
  const idTokenUser = useIdTokenUser()
  return (
    <UserManageAmbientDataContextProvider>
      <ListContextProvider value={controllerProps}>
        <UsersTable currentUserId={idTokenUser ? +idTokenUser.id : -1} />
      </ListContextProvider>
      <Box
        sx={{ mt: 4 }}
      >
        <ListContextProvider value={invitationCtrlProps}>
          <InvitationTable />
        </ListContextProvider>
      </Box>
    </UserManageAmbientDataContextProvider>
  )
}


